export default __webpack_public_path__ + "static/media/20.03f9f41b.png";